export class DataCatalogPipelineVersionChange {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "field",
            "baseName": "field",
            "type": "string",
            "format": ""
        },
        {
            "name": "before",
            "baseName": "before",
            "type": "string",
            "format": ""
        },
        {
            "name": "after",
            "baseName": "after",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DataCatalogPipelineVersionChange.attributeTypeMap;
    }
    constructor() {
    }
}
